import React, { useContext } from 'react';
import { DropdownMenu } from '@paypalcorp/pp-react-dropdown-menu';
import { CustomColumn } from '@MerchantConfigurator/components/common';
import {
  ConfigValues,
  MessagingAttributes,
  SelectionLabels
} from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context';
import { getOptions } from '@MerchantConfigurator/utils/messaging';
import PropTypes from 'prop-types';
import styles from './ControlPanel.module.less';
import { trackFieldChange } from '../../../../../lib/fpti';

const MessageConfigs = ({ placement, placementConfig, updateConfig, updateCounters }) => {
  const eventCounter = `${placement}_configs_updated`;
  const { content } = useContext(ApplicationContext);

  return (
    <CustomColumn>
      <DropdownMenu
        className={styles.control_panel_dropdown_menu}
        label={content[SelectionLabels.logoType]}
        value={placementConfig['logo-type']}
        options={getOptions({
          attribute: MessagingAttributes.logoType,
          content
        })}
        onChange={(event) => {
          updateConfig({
            placement,
            attribute: MessagingAttributes.logoType,
            value: event.target.value
          });
          trackFieldChange('Logo type', event.target.value);
          updateCounters(eventCounter);
        }}
      />
      <DropdownMenu
        className={styles.control_panel_dropdown_menu}
        label={content[SelectionLabels.textColor]}
        value={placementConfig['text-color']}
        options={getOptions({
          attribute: MessagingAttributes.textColor,
          content
        })}
        onChange={(event) => {
          updateConfig({
            placement,
            attribute: MessagingAttributes.textColor,
            value: event.target.value
          });
          trackFieldChange('Text Color', event.target.value);
          updateCounters(eventCounter);
        }}
      />
      {placementConfig['logo-type'] === ConfigValues.logoType.primary && (
        <DropdownMenu
          className={styles.control_panel_dropdown_menu}
          label={content[SelectionLabels.logoPosition]}
          value={placementConfig['logo-position']}
          options={getOptions({
            attribute: MessagingAttributes.logoPosition,
            content
          })}
          onChange={(event) => {
            updateConfig({
              placement,
              attribute: MessagingAttributes.logoPosition,
              value: event.target.value
            });
            trackFieldChange('Logo Position', event.target.value);
            updateCounters(eventCounter);
          }}
        />
      )}

      <DropdownMenu
        className={styles.control_panel_dropdown_menu}
        label={content[SelectionLabels.textSize]}
        value={placementConfig['text-size']}
        options={getOptions({
          attribute: MessagingAttributes.textSize,
          content
        })}
        onChange={(event) => {
          updateConfig({
            placement,
            attribute: MessagingAttributes.textSize,
            value: event.target.value
          });
          trackFieldChange('Text Size', event.target.value);
          updateCounters(eventCounter);
        }}
      />
    </CustomColumn>
  );
};

export default MessageConfigs;

MessageConfigs.propTypes = {
  placement: PropTypes.string,
  placementConfig: PropTypes.object,
  updateConfig: PropTypes.func,
  updateCounters: PropTypes.func
};
